import { TabGroup as CXTabGroup, ITab as CXITab } from '@sanlamcx/react-ui-next-tabs';

export type TabGroup = typeof CXTabGroup;

export type ITab = CXITab;
export const TabGroup: TabGroup = CXTabGroup;
